import { produce } from 'immer';
import type { HistorySnapshot } from '@/components/canvas/store/types';

/** 深拷贝，避免 _pendingBase 与 store 共享引用 */
export function cloneHistorySnapshot(snapshot: HistorySnapshot): HistorySnapshot {
  return produce(snapshot, () => {});
}
